import React from 'react';
import { Button } from '../../globalStyles';
import styled from 'styled-components';

import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
} from 'react-icons/fa';
import {
  SocialMedia,
  SocialMediaWrap,
  WebsiteRights,
  SocialIcons,
  SocialIconLink
} from './Footer.elements';
import { Heading, Img, ImgWrapper, InfoColumn, InfoRow } from '../InfoSection/InfoSection.elements';

function Footer() {
  return (
    <FooterContainer id='downloads'>
      <InfoColumn>
        <Heading whiteSpace lightText>Download the CallOn App</Heading>
      </InfoColumn>
      <InfoRow>
        <InfoColumn>
          <ImageButtonContainer onClick={() => alert('Coming Soon')}>
            <ImgWrapper borderWidth='2px' width={'240px'}>
              <Img src={require('../../assets/downloadOnAndroid.png')} />
            </ImgWrapper>
          </ImageButtonContainer>
        </InfoColumn>
        <InfoColumn>
          <a target="_blank" href="https://apps.apple.com/il/app/callon-internetional-calling/id1537469073">
            <ImgWrapper borderWidth={'2px'} width={'240px'}>
              <Img src={require('../../assets/downloadOnIOS.png')} />
            </ImgWrapper>
          </a>
        </InfoColumn>
      </InfoRow>

      <SocialMedia>
        {/* <SocialMediaWrap> */}
        {/* Social Icons */}
        {/* <SocialIcons> */}
        {/* <SocialIconLink href='/' target='_blank' aria-label='Facebook'>
              <FaFacebook />
            </SocialIconLink>
            <SocialIconLink href='/' target='_blank' aria-label='Instagram'>
              <FaInstagram />
            </SocialIconLink>
            <SocialIconLink
              href={'https://www.youtube.com/'}
              rel='noopener noreferrer'
              target='_blank'
              aria-label='Youtube'
            >
              <FaYoutube />
            </SocialIconLink> */}
        {/* </SocialIcons> */}

        {/* Rights */}
        <WebsiteRights>support@callon.app | CallOn © 2020</WebsiteRights>

        {/* </SocialMediaWrap> */}
      </SocialMedia>
    </FooterContainer>
  );
}

export default Footer;

const FooterContainer = styled.div`
  display: flex;
  background-color: #101522;
  flex-direction: column;
  align-items: center;
  padding: 4rem 0 2rem 0;
`;

const ImageButtonContainer = styled.button`
  background: transparent;
  outline: none;
  border: none;
  cursor: pointer;
`;
